import React from "react";
import {Col, Row, Spinner} from "react-bootstrap";

const Loader = (minHeight = 360) => (
    <Row>
        <Col>
            <div
                className='d-flex justify-content-center align-items-center'
                style={{minHeight: `${minHeight}px`}}
            >
                <Spinner animation="border"/>
            </div>
        </Col>
    </Row>

);

export default Loader;
